// extracted by mini-css-extract-plugin
module.exports = {"codeDiv":"_3KpKzHjUIaDLNnyEAT9Han","newCodeBtn":"_2wf8_t_7GUrWN97KAN3fzn","qrCode":"biHioNjmJeUUBRL6RWgQr"};